<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zlGYwi/tc-custom/9781607659228.jpg?1702236531933" alt="This image is the cover for the book Grow Your Own, Self-Sufficiency"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Grow Your Own, Self-Sufficiency
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Reap the advantages of backyard-to-table produce with tips on planning, soil, fertilizers, cultivation, pests, and diseases. Includes a Quickstart Guide!</b><br/><br/> This is a simple and systematic guide to growing a selection of the tastiest fruit and vegetables. The aim of this book is to start you off with some easy-to-grow produce such as carrots, onions, radishes, tomatoes and strawberries. Once you have the confidence of the first growing season behind you, you can then progress to crops requiring slightly more labor, such as peas, beans and raspberries. When you grow your own produce, you can be absolutely sure that everything has been organically cared for and you can grow just the variety you like. You can pick the fruit and vegetables at their freshest without a tiresome journey to the supermarket. It’s satisfying, it’s economical and it’s delicious.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ian Cooke
      </h2>
      
      <p class="authorDescription body article">Ian Cooke has been a professional horticulturalist for over forty years. He runs his own consultancy, advising, designing, and writing on all matters horticultural, and is the author of six gardening books. He splits his time between the U.K. and the United States.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      IMM Lifestyle Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1fdb864f